(function initPartnersAndClientsTicker() {
  const tracks = document.querySelectorAll(".partners-and-clients__track");
  if (!tracks.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const IDLE_SPEED = 48;
  const SCROLL_SPEED = 220;
  const STOP_DELAY = 220;
  const DAMPING = 58;
  const STIFFNESS = 320;

  let scrollDir = 1;
  let hasScrolled = false;
  let targetSpeed = IDLE_SPEED;
  let lastScrollY = window.scrollY;
  let stopTimeout = null;

  function createSpring(initial) {
    let pos = initial;
    let vel = 0;
    return {
      update(target, dt) {
        const s = Math.min(dt, 64) / 1000;
        const f = -STIFFNESS * (pos - target) - DAMPING * vel;
        vel += f * s;
        pos += vel * s;
        return pos;
      },
    };
  }

  function wrap(x, width) {
    if (width <= 0) return x;
    return (((x % width) + width) % width) - width;
  }

  function createRow(track) {
    const group = track.querySelector(".partners-and-clients__group");
    const reverse =
      track.closest(".partners-and-clients__ticker--reverse") !== null;
    const baseDir = reverse ? 1 : -1;
    const spring = createSpring(baseDir * IDLE_SPEED);

    let offset = 0;
    let lastTime = null;

    return function tick(now) {
      if (lastTime === null) {
        lastTime = now;
        return;
      }
      const dt = now - lastTime;
      lastTime = now;

      const groupWidth = group ? group.offsetWidth : 0;
      if (groupWidth === 0) return;

      const magnitude = targetSpeed === IDLE_SPEED ? IDLE_SPEED : SCROLL_SPEED;
      const springTarget = hasScrolled
        ? -baseDir * scrollDir * magnitude
        : baseDir * magnitude;

      const speed = spring.update(springTarget, dt);
      offset = wrap(offset + speed * (dt / 1000), groupWidth);
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    };
  }

  const rows = Array.from(tracks).map(createRow);

  window.addEventListener(
    "scroll",
    () => {
      const dy = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      if (dy !== 0) {
        scrollDir = dy > 0 ? 1 : -1;
        hasScrolled = true;
      }
      targetSpeed = SCROLL_SPEED;

      clearTimeout(stopTimeout);
      stopTimeout = setTimeout(() => {
        targetSpeed = IDLE_SPEED;
      }, STOP_DELAY);
    },
    { passive: true },
  );

  function loop(now) {
    rows.forEach((tick) => tick(now));
    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);
})();
